import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Row, Col, Table, Dropdown, Button, Divider, Modal, DatePicker, MenuProps, Image } from "antd";
// import type { MenuProps } from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  PrinterOutlined,
  ReloadOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  ControlFilled,
} from "@ant-design/icons";
import {
  getShipmentsService,
  getShipmentsMaterialsService,
  getMetalsService,
  getMaterialService,
  getShipmentPDF,
  deleteShipmentService,
} from "./ShipmentsPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import Loader from "../../components/Loader/Loader";
import "./ShipmentsPage.css";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import printJS from "print-js";
import Cookies from "universal-cookie";

const { Content } = Layout;

export interface ShipmentsPageProps {}

const ShipmentsPage = (props: ShipmentsPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [shipmentsList, setShipmentsList] = useState([]) as any;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalShipments, setTotalShipments] = useState(0);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [shipmentToDelete, setShipmentToDelete] = useState({}) as any;
  const [loading, setLoading] = useState(true);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [metals, setMetals] = useState([]);
  const [printPurchaseData, setPrintPurchaseData] = useState(null) as any;
  const [shipmentDetailsTableData, setShipmentDetailsTableData] = useState([]) as any;
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  let navigate = useNavigate();
  let officeNameFormat: any = {
    pg: "Penang (PG)",
    bw: "Butterworth (BW)",
  };
  const shipmentColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Date",
      key: "date",
      align: "center",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Origin",
      key: "origin",
      dataIndex: "origin",
      align: "center",
      render: (record: any) => officeNameFormat[record],
    },
    {
      title: "Destination",
      key: "dest",
      dataIndex: "dest",
      align: "center",
      render: (record: any) => officeNameFormat[record],
    },
    {
      title: "Lorry Number Plate",
      key: "lorryNumberPlate",
      dataIndex: "lorryNumberPlate",
      align: "center",
      render: (record: any) => record,
    },
    {
      title: "Driver",
      key: "driver",
      dataIndex: "driver",
      align: "center",
      render: (record: any) => record,
    },
    {
      title: "Total Net Weight (kg)",
      key: "totalNetWeight",
      align: "center",
      render: (record: any) =>
        record.totalNetWeight === null || record.totalNetWeight === undefined
          ? Number(record.totalRawWeight).toFixed(1)
          : Number(record.totalNetWeight).toFixed(1),
    },
    {
      title: "Materials",
      key: "materials",
      render: (record: any) => {
        return `${record.materialIDList.length} items`;
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
      align: "center",
      render: (record: any) => (record ? "Yes" : "No"),
    },
    // {
    //   title: "Generate Bill",
    //   key: "generateBill",
    //   align: "center",
    //   render: (record: any) =>
    //     record.completed && !record.billIssued ? (
    //       <Button type="primary" size="small" onClick={() => generateBill(record.purchaseID, record.supplierID)}>
    //         Generate Bill
    //       </Button>
    //     ) : null,
    // },
    // {
    //   title: "Print Purchase",
    //   key: "printPurchase",
    //   align: "center",
    //   render: (record: any) =>
    //     record.completed ? (
    //       <Button type="primary" size="small" onClick={() => printPurchase(record)} icon={<PrinterOutlined />}>
    //         Print Purchase
    //       </Button>
    //     ) : null,
    // },
    {
      title: "Options",
      key: "options",
      align: "center",
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        if (record.completed) items.push({ key: "print", label: "Print Shipment", icon: <PrinterOutlined /> });
        record.completed && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Shipment", icon: <FolderOpenOutlined /> })
          : items.push({ key: "edit", label: "Edit Shipment", icon: <EditOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Shipment", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editPurchase(record);
                else if (key === "delete") openDeleteShipmentModal(record);
                // else if (key === "print") printPurchase(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const shipmentDetailsColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) =>
        record.scaleImageURL ? <Image height={50} width={50} src={record.scaleImageURL} /> : <></>,
      align: "center" as const,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) =>
        record.materialImageURL ? <Image height={50} width={50} src={record.materialImageURL} /> : <></>,
      align: "center" as const,
    },
    {
      title: "Material Name",
      dataIndex: "displayName",
      align: "center" as const,
      render: (name: string) => <strong>{name}</strong>,
    },
    {
      title: "Package Type",
      key: "packageType",
      dataIndex: "packageType",
      align: "left" as const,
      render: (record: any) => record,
    },
    {
      title: "Raw Weight (kg)",
      key: "rawWeight",
      // dateIndex: "rawWeight",
      align: "center" as const,
      render: (record: any) => {
        return record ? Number(record.rawWeight).toFixed(1) : null;
      },
    },
    {
      title: "Waste Weight (kg)",
      key: "wasteWeight",
      dateIndex: "wasteWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        let wasteInfo = "(";
        if (record.smallBag > 0) {
          if (record.bigBag > 0) wasteInfo += `${record.smallBag} small, `;
          else wasteInfo += `${record.smallBag} small`;
        }
        if (record.bigBag > 0) {
          if (record.jumboBag > 0) wasteInfo += `${record.bigBag} big, `;
          else wasteInfo += `${record.bigBag} big`;
        }
        if (record.jumboBag > 0) {
          wasteInfo += `${record.jumboBag} jumbo`;
        }
        wasteInfo += ")";
        return (
          <>
            <Row justify="center"> - {Number(record.wasteWeight).toFixed(1)}</Row>
            {(record.smallBag > 0 || record.bigBag > 0 || record.jumboBag > 0) && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                {wasteInfo}
              </Row>
            )}
          </>
        );
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      dateIndex: "netWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        return <strong>{Number(record.netWeight).toFixed(1)}</strong>;
      },
    },
    {
      title: "Manual Entry",
      dataIndex: "originManualEntry",
      key: "completed",
      align: "center" as const,
      render: (record: any) =>
        record ? (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "orange", marginRight: "5px" }} />
            Yes
          </>
        ) : (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "green", marginRight: "5px" }} />
            No
          </>
        ),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getMetals();
  }, []);

  useEffect(() => {
    getShipments(currentPage);
  }, [currentPage]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getShipments = async (pageNumber: Number) => {
    try {
      setLoading(true);
      const res = await getShipmentsService(String(pageNumber));
      setTotalPages(res.data.totalPages);
      setTotalShipments(res.data.totalShipments);
      const updatedShipments = [...res.data.shipments];
      for (let shipment of updatedShipments) {
        shipment.key = shipment.shipmentID;
      }
      setShipmentsList(updatedShipments);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getShipments error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getShipmentsMaterial = async (materialID: string) => {
    try {
      const res = await getMaterialService(materialID);
      return res;
    } catch (e: any) {
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  // const generateBill = async (purchaseID: string, supplierID: string) => {
  //   try {
  //     setLoading(true);
  //     const payload = {
  //       purchaseID: purchaseID,
  //       supplierID: supplierID,
  //       office: "pg",
  //     };
  //     const res = await postBillService(payload);
  //     setLoading(false);
  //     navigate(`/bill/${res.data.billID}`);
  //   } catch (e: any) {
  //     setLoading(false);
  //     console.error("generateBill error", e);
  //     if (e.response.status === 401) {
  //       removeTokenFromCookies();
  //       navToLogin();
  //     }
  //   }
  // };

  // const printPurchase = async (purchaseDetails: any) => {
  //   try {
  //     setLoading(true);
  //     const fileName = formatPurchaseSupplierFileName(purchaseDetails.supplierID, purchaseDetails.purchaseID);
  //     const res = await getPurchasePDF(fileName);
  //     setPrintPurchaseData(res.data);
  //     setIsPDFModalOpen(true);
  //     setLoading(false);
  //   } catch (e: any) {
  //     setLoading(false);
  //     console.error("printPurchase error", e);
  //     if (e.response.status === 401) {
  //       removeTokenFromCookies();
  //       navToLogin();
  //     }
  //   }
  // };

  const closePDFModal = () => {
    setIsPDFModalOpen(false);
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const getShipmentExpandedDetails = async (shipmentID: string) => {
    try {
      setLoading(true);
      const currShipment = shipmentsList.find((shipment: any) => shipment.shipmentID === shipmentID);
      const currMaterials: any[] = [];
      for (let materialID of currShipment.materialIDList) {
        const resMaterial: any = await getShipmentsMaterial(materialID);
        const materialData = resMaterial.data;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        materialData.key = materialData.materialID;
        //temp fix for now
        materialData.rawWeight = materialData.originRawWeight;
        materialData.wasteWeight = materialData.originWasteWeight;
        materialData.netWeight = materialData.originNetWeight;
        materialData.smallBag = materialData.originSmallBag;
        materialData.bigBag = materialData.originBigBag;
        materialData.jumboBag = materialData.originJumboBag;
        materialData.scaleImageURL = materialData.originScaleImageURL;
        materialData.materialImageURL = materialData.originMaterialImageURL;
        //temp fix for now
        currMaterials.push(materialData);
      }
      const newShipmentDetails = [...shipmentDetailsTableData];
      const newShipmentDetailsObject = {
        shipmentID: shipmentID,
        materialsList: currMaterials,
      };
      newShipmentDetails.push(newShipmentDetailsObject);
      setShipmentDetailsTableData([...newShipmentDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getShipmentExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const displayShipmentDetails = (shipmentID: string) => {
    const currShipment = shipmentsList.find((shipment: any) => shipment.shipmentID === shipmentID);
    const currShipmentDetails = shipmentDetailsTableData.find((shipment: any) => shipment.shipmentID === shipmentID);
    return (
      <Row justify="center">
        <Col span={20}>
          <Table
            // dataSource={[]}
            dataSource={[...currShipmentDetails.materialsList]}
            columns={shipmentDetailsColumns}
            pagination={false}
          />
          {currShipment.notes && (
            <>
              <Row style={{ margin: "10px 0" }}>
                <strong>Notes</strong>
              </Row>
              <Row>{currShipment.notes}</Row>
            </>
          )}
        </Col>
      </Row>
    );
  };

  const openDeleteShipmentModal = (record: any) => {
    setShipmentToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteShipment = async () => {
    setIsDeleteModalOpen(false);
    await deleteShipment(shipmentToDelete.purchaseID);
    await getShipments(currentPage);
  };

  const deleteShipment = async (shipmentID: string) => {
    try {
      setLoading(true);
      const res = await deleteShipmentService(shipmentID);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteShipment error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const declineDeleteShipment = () => {
    shipmentToDelete({});
    setIsDeleteModalOpen(false);
  };

  const editPurchase = (record: any) => {
    navigate(`/shipment/${record.shipmentID}`);
  };

  const printPurchasePDF = () => {
    printJS({ printable: encodeURI(printPurchaseData), type: "pdf", base64: true });
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="shipments-title">Shipments</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => getShipments(currentPage)}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              className="shipments-table"
              dataSource={[...shipmentsList]}
              columns={shipmentColumns}
              pagination={{
                pageSize: 20,
                total: totalShipments,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getShipments(page);
                },
              }}
              expandedRowRender={(record) => displayShipmentDetails(record.shipmentID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getShipmentExpandedDetails(record.shipmentID);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Delete Shipment"
        open={isDeleteModalOpen}
        okText="Confirm Delete"
        okType="danger"
        onOk={confirmDeleteShipment}
        onCancel={declineDeleteShipment}
      >
        <p>
          Are you sure you want to delete this shipment on{" "}
          <strong>{new Date(shipmentToDelete.createdTimestamp).toLocaleDateString("en-GB")}</strong>?
        </p>
        <p>This will permanently delete this shipment and this action cannot be undone.</p>
      </Modal>
      <Modal
        title="Purchase PDF"
        style={{ height: "600px" }}
        open={isPDFModalOpen}
        okText="Print"
        onOk={printPurchasePDF}
        onCancel={closePDFModal}
      >
        <iframe
          title="printBill"
          id="printBill"
          src={`data:application/pdf;base64, ${encodeURI(printPurchaseData)}`}
          height="500px"
          width="100%"
        ></iframe>
      </Modal>
    </Layout>
  );
};

export default ShipmentsPage;
